import { API_URL } from '@/modules/shared/constants/API_URL'
import { httpAuthenticationInterceptor } from '@/modules/shared/modules/http/domain/services/HTTPAuthenticationInterceptor'
import HTTPExceptionInterceptor from '@/modules/shared/modules/http/domain/services/HTTPExceptionInterceptor'
import { httpTokenInterceptor } from '@/modules/shared/modules/http/domain/services/HTTPTokenInterceptor'

import { buildParams } from '../../../../../../ui/utils/buildParams'
import { CAAMetrics } from '../../domain/models/CAAMetrics'
import { CAAMetricsDatasource } from '../../infra/datasources/CAAMetricsDatasource'

export const caaMetricsDatasourceAdapter: CAAMetricsDatasource = {
  async getPatientCAAMetricsWeek({ patientId, personaName, date }) {
    const search = buildParams({ personaName, date })
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/${patientId}/metrics-caa-weeks?${search}`,
          httpTokenInterceptor({ method: 'GET' })
        )
      )
    )
    return CAAMetrics.parse(await response.json())
  },

  async getPatientCAAMetricsMonth({ patientId, personaName, month, year }) {
    const search = buildParams({ personaName, month, year })
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/${patientId}/metrics-caa-month?${search}`,
          httpTokenInterceptor({ method: 'GET' })
        )
      )
    )
    return CAAMetrics.parse(await response.json())
  },

  async getPatientCAAMetricsSemester({ patientId, personaName, period, year }) {
    const search = buildParams({ personaName, period, year })
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/${patientId}/metrics-caa-semester?${search}`,
          httpTokenInterceptor({ method: 'GET' })
        )
      )
    )
    return CAAMetrics.parse(await response.json())
  },

  async getPatientCAAMetricsYear({ patientId, personaName, year }) {
    const search = buildParams({ personaName, year })
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/${patientId}/metrics-caa-year?${search}`,
          httpTokenInterceptor({ method: 'GET' })
        )
      )
    )
    return CAAMetrics.parse(await response.json())
  },

  async getOperationalCAAMetricsPatientWeek({ personaName, date }) {
    const search = buildParams({ personaName, date })
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/caa-weeks?${search}`,
          httpTokenInterceptor({ method: 'GET' })
        )
      )
    )
    return CAAMetrics.parse(await response.json())
  },

  async getOperationalCAAMetricsPatientMonth({ personaName, month, year }) {
    const search = buildParams({ personaName, month, year })
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/caa-month?${search}`,
          httpTokenInterceptor({ method: 'GET' })
        )
      )
    )
    return CAAMetrics.parse(await response.json())
  },

  async getOperationalCAAMetricsPatientSemester({ personaName, period, year }) {
    const search = buildParams({ personaName, period, year })
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/caa-semester?${search}`,
          httpTokenInterceptor({ method: 'GET' })
        )
      )
    )
    return CAAMetrics.parse(await response.json())
  },

  async getOperationalCAAMetricsPatientYear({ personaName, year }) {
    const search = buildParams({ personaName, year })
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/caa-year?${search}`,
          httpTokenInterceptor({ method: 'GET' })
        )
      )
    )
    return CAAMetrics.parse(await response.json())
  },

  async getOperationalCAAMetricsTherapistWeek({ personaName, date }) {
    const search = buildParams({ personaName, date })
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/therapists/caa-weeks?${search}`,
          httpTokenInterceptor({ method: 'GET' })
        )
      )
    )
    return CAAMetrics.parse(await response.json())
  },

  async getOperationalCAAMetricsTherapistMonth({ personaName, month, year }) {
    const search = buildParams({ personaName, month, year })
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/therapists/caa-month?${search}`,
          httpTokenInterceptor({ method: 'GET' })
        )
      )
    )
    return CAAMetrics.parse(await response.json())
  },

  async getOperationalCAAMetricsTherapistSemester({
    personaName,
    period,
    year
  }) {
    const search = buildParams({ personaName, period, year })
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/therapists/caa-semester?${search}`,
          httpTokenInterceptor({ method: 'GET' })
        )
      )
    )
    return CAAMetrics.parse(await response.json())
  },

  async getOperationalCAAMetricsTherapistYear({ personaName, year }) {
    const search = buildParams({ personaName, year })
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/therapists/caa-year?${search}`,
          httpTokenInterceptor({ method: 'GET' })
        )
      )
    )
    return CAAMetrics.parse(await response.json())
  }
}
